import { render, staticRenderFns } from "./Preliquidation.vue?vue&type=template&id=008a4bef"
import script from "./Preliquidation.vue?vue&type=script&lang=js"
export * from "./Preliquidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports